module.exports = __webpack_public_path__ + "static/media/Group_Members.3d2dfd7a.svg";